import { isArray, isPlainObject, find } from 'lodash-es'
// import PREFIX from "../prefix-config.js";

/**
 * 对比两个object对象，数据是否一致。
 * data 新数据
 * oldData 旧数据
 * deep 是否深度递归对象
 */
export function objHasChange(data, oldData, deep) {
  let flag = false
  find(data, (val, key) => {
    if (deep && isPlainObject(oldData[key]) && isPlainObject(val)) {
      flag = objHasChange(val, oldData[key], deep)
    } else {
      flag = val !== oldData[key]
    }
    return flag
  })
  return flag
}

/**
 * 对比两个数据是否一致
 * @param {*} d1 数据1
 * @param {*} d2 数据2
 * @param {*} deep 对象时是否递归
 */
export function isEqual(d1, d2, deep = true) {
  let isEqualForInner = (obj1, obj2) => {
    var o1 = obj1 instanceof Object
    var o2 = obj2 instanceof Object
    if (!o1 || !o2) {
      return obj1 === obj2
    }
    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
      return false
    }
    for (var attr in obj1) {
      var t1 = obj1[attr] instanceof Object
      var t2 = obj2[attr] instanceof Object
      if (t1 && t2 && deep) {
        return isEqualForInner(obj1[attr], obj2[attr])
      } else if (obj1[attr] !== obj2[attr]) {
        return false
      }
    }
    return true
  }
  return isEqualForInner(d1, d2)
}

/**
 * item翻译value。
 * 通过配置opts或者指定dict进行翻译
 */
export function transValue(val, item, $dict) {
  if (val === undefined || val === null) {
    return ''
  }
  if (!item) {
    return val
  }
  let getOptsText = (v, key) => {
    key = key || 'opts'
    let keyField = item.valueKey || 'value'
    let textField = item.labelKey || 'label'
    let separateChar = item.optSeparater || '-'
    let opt = find(item[key], (obj) => {
      return obj[keyField] === v
    })
    if (opt) {
      return isArray(textField)
        ? textField
            .map((key) => {
              return opt[key]
            })
            .join(separateChar)
        : opt[textField]
    } else {
      return v
    }
  }
  let getDictText = (v) => {
    let text = $dict.translate(item.dict, v)
    if (!text) {
      text = v
    }
    return text
  }
  if (isArray(item.opts) || isArray(item.options)) {
    const key = isArray(item.opts) ? 'opts' : 'options'
    if (item.multiple) {
      let separateChar = item.valSeparateChar || ','
      return val
        .split(separateChar)
        .map((v) => {
          return getOptsText(v, key)
        })
        .join(separateChar)
    } else {
      return getOptsText(val, key)
    }
  } else if (item.dict && val) {
    if (item.multiple) {
      let separateChar = item.valSeparateChar || ','
      return val
        .split(separateChar)
        .map((v) => {
          return getDictText(v)
        })
        .join(separateChar)
    } else {
      return getDictText(val)
    }
  }
  return val
}

export function indexOf(arr, key) {
  return arr.findIndex((m) => m === key)
}

/**
 * 字符串转数字
 * @param {any} val 字符串
 * @returns
 */
export function transStrToNumber(val) {
  if (val === null || val === undefined || isNaN(val)) {
    return ''
  }
  if (val.toString().trim() === '') {
    return ''
  }
  return Number(val)
}

/**
 * 获取组件名称
 */
export function getCmpName(mold) {
  // 组件库前缀
  let uiprefix = localStorage.getItem('UI-PREFIX')
  let PREFIX = []
  if (uiprefix) {
    PREFIX = uiprefix.split(',')
  }
  let pre = PREFIX.find((p) => mold.startsWith(p))
  if (pre) {
    return mold
  } else {
    return 'kui-' + mold
  }
}

/**
 * 下拉框多选，值为字符串处理
 * 数字，字符串输入格式分别为： "1, 2, 3",    "'124', '345'"
 */
export function splitStringToArr(val) {
  if (val && typeof val === 'string') {
    val = val.split(',')
    return val.map((value) => {
      const i = parseInt(value, 10)
      if (isNaN(i)) {
        if (
          value.length >= 3 &&
          ((value.substring(0, 1) === '"' && value.substring(value.length - 1, value.length) === '"') ||
            (value.substring(0, 1) === "'" && value.substring(value.length - 1, value.length) === "'"))
        ) {
          value = value.substring(1, value.length - 1)
        }
        return value
      } else {
        return i
      }
    })
  } else {
    return []
  }
}

export function splitArrToString(val) {
  let re = ''
  if (val && Array.isArray(val)) {
    for (let i = 0; i < val.length; i++) {
      let item = val[i]
      if (typeof item !== 'number') {
        re += "'" + item + "'" + ','
      } else {
        re += item + ','
      }
    }
    if (re) {
      re = re.substring(0, re.length - 1)
    }
    return re
  } else {
    return val
  }
}

export function stringify(obj) {
  try {
    return JSON.stringify(obj, (k, v) => {
      if (typeof v === 'function') {
        return `FUNCTION_FLAG ${v}`
      } else {
        return v
      }
    })
  } catch (error) {
    console.log(error)
  }
}

export function parse(jsonStr) {
  try {
    return JSON.parse(jsonStr, (k, v) => {
      if (v && typeof v === 'string') {
        return v.includes('FUNCTION_FLAG') ? new Function(`return ${v.replace('FUNCTION_FLAG', '')}`)() : v
      }
      return v
    })
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/utils/utils.js